// extracted by mini-css-extract-plugin
export var notificationHost = "_lk-0";